import React from "react";
import Item from "./Item";
import SeparatorSVG from "./SeparatorSVG";
import { features } from "./data";

const splitIndex = 3;

function Pricing() {
  return (
    <section className="bg-gray-50 py-12 sm:py-16 lg:py-20" id="pricing">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="mx-auto flex flex-col items-center justify-center md:w-3/4 md:flex-row">
            <h2 className="text-2xl font-bold text-gray-900 sm:text-3xl md:text-4xl">
              Everything You Need—No Limits, One Simple Price
            </h2>
          </div>
        </div>

        <div className="relative mx-auto mt-8 max-w-sm md:mt-12 md:max-w-6xl">
          <div className="absolute -inset-4">
            <div
              className="mx-auto size-full opacity-30 blur-lg"
              style={{
                background:
                  "linear-gradient(90deg, #44ff9a -0.55%, #44b0ff 22.86%, #8b44ff 48.36%, #ff6644 73.33%, #ebff70 99.34%)",
              }}
            />
          </div>

          <div className="relative overflow-hidden rounded-2xl border border-gray-200 bg-white">
            <div className="p-4 sm:p-6 md:px-10 md:py-9">
              <div className="grid grid-cols-1 items-center gap-y-6 sm:gap-y-9 md:grid-cols-7 md:gap-y-0">
                <div className="space-y-6 sm:space-y-9 md:col-span-3 xl:pr-2">
                  {features.slice(0, splitIndex).map(feature => (
                    <Item key={feature} title={feature} />
                  ))}
                </div>

                <div className="my-6 md:my-0">
                  <div className="hidden md:block">
                    <SeparatorSVG />
                  </div>
                  <div className="block md:hidden">
                    <SeparatorSVG mobile />
                  </div>
                </div>

                <div className="space-y-6 sm:space-y-9 md:col-span-3 xl:pl-2">
                  {features.slice(splitIndex).map(feature => (
                    <Item key={feature} title={feature} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 text-center sm:mt-8">
          <div className="mt-6 flex items-end justify-center sm:mt-8 md:mt-10">
            <div className="text-xl font-bold text-gray-900 sm:text-2xl md:text-3xl lg:text-4xl">
              <p className="leading-tight">Get $1,200+ of features every month — pay only $299/month.</p>
              <p className="mt-2 leading-tight">Pay monthly, no long-term contracts.</p>
            </div>
          </div>

          <a
            href="#signup"
            title="Get started for $299 only"
            className="relative mt-6 inline-flex w-full items-center justify-center rounded-xl border border-transparent bg-gray-900 px-6 py-3 text-sm font-bold text-white transition-all duration-200 hover:bg-gray-900/90 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2 sm:mt-8 sm:w-auto sm:px-8 sm:py-3.5 sm:text-base md:mt-9"
            role="button"
          >
            Get full access for $299/month
          </a>

          <p className="mt-3 px-4 text-xs font-normal text-gray-600 sm:mt-4 sm:px-0 sm:text-sm">
            Included at no extra cost: up to 4 hours of personalized live support and training.
          </p>
        </div>
      </div>
    </section>
  );
}

export default React.memo(Pricing);
